import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import { AssessmentProcessProviderWrapper } from '@/features/assessment/process/contexts/AssessmentProcessProviderWrapper'
import { AssessmentProcessLayout } from '@/features/assessment/process/layouts/AssessmentProcessLayout'
import { MainLayout } from '@/layouts'

export const assessmentRoutes: RouteObject = {
  path: 'assessments',
  element: <MainLayout />,
  children: [
    {
      index: true,
      lazy: async () => {
        const module = await import('@/features/assessment/management/pages/AssessmentListPage')
        return {
          element: <module.AssessmentListPage />
        }
      }
    },
    {
      path: 'create',
      lazy: async () => {
        const module = await import('@/features/assessment/management/pages/AssessmentCreatePage')
        return {
          element: <module.AssessmentCreatePage />
        }
      }
    },
    {
      path: ':id/edit',
      lazy: async () => {
        const module = await import('@/features/assessment/management/pages/AssessmentEditPage')
        return {
          element: <module.AssessmentEditPage />
        }
      }
    }
  ]
}

// Assessment process routes with dedicated layout
export const assessmentProcessRoutes: RouteObject = {
  path: 'assessments/:id',
  element: (
    <AssessmentProcessProviderWrapper>
      <AssessmentProcessLayout />
    </AssessmentProcessProviderWrapper>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="dashboard" replace />
    },
    {
      path: 'dashboard',
      lazy: async () => {
        const module = await import(
          '@/features/assessment/process/pages/AssessmentProcessDashboard'
        )
        return {
          element: <module.AssessmentProcessDashboard />
        }
      }
    },
    {
      path: 'maturity',
      lazy: async () => {
        const module = await import(
          '@/features/assessment/process/pages/AssessmentProcessPhase1Maturity'
        )
        return {
          element: <module.AssessmentProcessPhase1Maturity />
        }
      }
    },
    {
      path: 'gap-analysis',
      lazy: async () => {
        const module = await import(
          '@/features/assessment/process/pages/AssessmentProcessPhase2GapAnalysis'
        )
        return {
          element: <module.AssessmentProcessPhase2GapAnalysis />
        }
      }
    },
    {
      path: 'recommendations',
      lazy: async () => {
        const module = await import(
          '@/features/assessment/process/pages/AssessmentProcessPhase3Recommendation'
        )
        return {
          element: <module.AssessmentProcessPhase3Recommendation />
        }
      }
    },
    {
      path: 'planning',
      lazy: async () => {
        const module = await import(
          '@/features/assessment/process/pages/AssessmentProcessPhase4Planning'
        )
        return {
          element: <module.AssessmentProcessPhase4Planning />
        }
      }
    },
    {
      path: 'reportes',
      lazy: async () => {
        const { ReportesPage } = await import(
          '@/features/assessment/process/reports/pages/ReportesPage'
        )
        return { element: <ReportesPage /> }
      }
    }
  ]
}
